import { SHARED_DEALS } from '../sharedConfig';

// budgetAllocation values are relative weights, NOT percentages.
// The formula (weight / sumOfSelectedWeights) × sourceBudget distributes 100%
// of the source line item's budget across whichever items are enabled.
export default {
  key: 'orangellow',
  label: 'Orangellow Display Strategy',
  strategySets: {
    prospecting: {
      label: 'Prospecting (10 items)',
      lineItems: [
        { name: 'CPM_Broad_21+_X_DIS_Prospecting', segment: 'BROAD_21PLUS', budgetAllocation: 20 },
        { name: 'CPM_BT_Cannabis_Interest_WithSegments_DIS_Prospecting', segment: 'CANNABIS_INTEREST', budgetAllocation: 5 },
        { name: 'CPM_BT_CannabisDeliveryResearchers_KnownResearchers_WithSegments_DIS_Prospecting', segment: 'CANNABIS_DELIVERY', budgetAllocation: 5 },
        { name: 'CPM_BT_DispensaryVisitors_KnownVisitors_WithSegments_DIS_Prospecting', segment: 'DISPENSARY_VISITORS', budgetAllocation: 5 },
        { name: 'CPM_BT_DispensaryResearchers_KnownResearchers_WithSegments_DIS_Prospecting', segment: 'DISPENSARY_RESEARCH', budgetAllocation: 5 },
        { name: 'CPM_BT_CalmGummies_Interest_WithSegments_DIS_Prospecting', segment: 'CALM_GUMMIES', budgetAllocation: 5 },
        { name: 'CPM_BT_HolisticMedicine_Interest_WithSegments_DIS_Prospecting', segment: 'HOLISTIC_MEDICINE', budgetAllocation: 5 },
        { name: 'CPM_BT_Vape_Interest_WithSegments_DIS_Prospecting', segment: 'VAPE', budgetAllocation: 5 },
        { name: 'CPM_BT_SmokeShopVisitors_KnownVisitors_WithSegments_DIS_Prospecting', segment: 'SMOKE_SHOP', budgetAllocation: 5 },
      ],
    },
    conquesting: {
      label: 'Conquesting (5 items)',
      lineItems: [
        { name: 'CPM_Broad_Broad_X_21+_DIS_Conquesting', segment: 'BROAD_21PLUS', budgetAllocation: 20 },
        { name: 'CPM_CQ_Cannabis_Interest_WithSegments_DIS_Conquesting', segment: 'CANNABIS_INTEREST', budgetAllocation: 5 },
        { name: 'CPM_CQ_CannabisDeliveryResearchers_KnownResearchers_WithSegments_DIS_Conquesting', segment: 'CANNABIS_DELIVERY', budgetAllocation: 5 },
        { name: 'CPM_CQ_DispensaryVisitors_KnownVisitors_WithSegments_DIS_Conquesting', segment: 'DISPENSARY_VISITORS', budgetAllocation: 5 },
        { name: 'CPM_CQ_DispensaryResearchers_KnownResearchers_WithSegments_DIS_Conquesting', segment: 'DISPENSARY_RESEARCH', budgetAllocation: 5 },
      ],
    },
  },
  deals: SHARED_DEALS,
};
